import script from "./DetailWorkView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailWorkView.vue?vue&type=script&setup=true&lang=ts"

import "./DetailWorkView.vue?vue&type=style&index=0&id=b3c5b3ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3c5b3ec"]])

export default __exports__